import React from 'react';
import Icon from '../Icon';
import Eyebrow from '../page/Eyebrow';
import { tie } from '../page/typography';

/**
 * Зміст сторінки питань: розділи-якорі з кількістю питань у кожному.
 *
 * Раніше розділи стояли в картці збоку з галочками й номерами 01–08 — вони
 * виглядали як перелік переваг, а не як посилання, і після першого ж екрана
 * зникали: далі йшло двадцять екранів відповідей без жодного орієнтира.
 *
 * Стрілка вниз ліворуч каже, що пункт веде нижче по сторінці, а число
 * праворуч — скільки там питань. Для екранного диктора число озвучується
 * словами («5 запитань»), бо сама цифра після назви розділу нічого не каже.
 *
 * Липкість задає сторінка (обгортка з lg:sticky), а не цей блок: на телефоні
 * зміст стоїть звичайним блоком над відповідями.
 */
const FaqNav = ({ id, title, total, groups }) => (
  <nav
    id={id}
    aria-labelledby={`${id}-title`}
    className="scroll-mt-24 rounded-2xl border border-slate-200 bg-slate-50 p-3 sm:p-4 lg:p-3"
  >
    <div className="flex items-center justify-between gap-4 px-3 pt-2 pb-2">
      <Eyebrow as="h2" id={`${id}-title`} className="">
        {title}
      </Eyebrow>
      {total && <p className="text-xs text-slate-600 whitespace-nowrap">{total}</p>}
    </div>
    <ul className="list-none grid sm:grid-cols-2 sm:gap-x-3 lg:grid-cols-1">
      {groups.map((group) => (
        <li key={group.id}>
          {/* Від lg рядки нижчі й кегль менший: колонка вузька, а зміст
              разом із закликом під ним має вміститися у висоту ноутбука.
              Мишею в рядок 36px влучити легко; на дотик — 44px. */}
          <a
            href={`#${group.id}`}
            className="group flex min-h-[2.75rem] lg:min-h-[2.25rem] items-center gap-3 rounded-lg px-3 py-2 lg:py-1.5 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 transition-colors duration-200"
          >
            <Icon
              name="fa-arrow-right"
              className="flex-shrink-0 rotate-90 text-[0.7rem] text-teal-700 transition-transform duration-200 motion-reduce:transition-none group-hover:translate-y-0.5"
            />
            <span className="flex-1 min-w-0 text-[0.95rem] lg:text-sm font-medium leading-snug text-balance text-slate-800 group-hover:text-teal-800 transition-colors duration-200">
              {tie(group.title)}
            </span>
            <span
              aria-hidden="true"
              className="flex-shrink-0 min-w-[1.75rem] rounded-full border border-slate-200 bg-white px-2 py-0.5 text-center text-xs font-semibold tabular-nums text-slate-600 group-hover:border-teal-200"
            >
              {group.faq.length}
            </span>
            <span className="sr-only">, {group.countLabel}</span>
          </a>
        </li>
      ))}
    </ul>
  </nav>
);

export default FaqNav;
